import React from 'react';
import { useTranslation } from 'react-i18next';
import { UploadCloud } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useGreeting } from '@hooks/useGreeting';

interface GreetingHeaderProps {
  onUpload: () => void;
}

const GreetingHeader: React.FC<GreetingHeaderProps> = ({ onUpload }) => {
  const { t } = useTranslation();
  const greeting = useGreeting();

  return (
    <header className="flex flex-wrap items-end justify-between gap-4">
      <div className="min-w-0">
        <h1 className="revy-cjk text-2xl font-semibold leading-[1.4] tracking-tight @lg/page:text-3xl">
          {greeting.message}
        </h1>
        <p className="revy-cjk mt-1 text-sm leading-[1.6] text-muted-foreground">
          {t('dashboard.subtitle')}
        </p>
      </div>

      <Button
        onClick={onUpload}
        className="shrink-0 shadow-sm transition-[scale,box-shadow] hover:shadow-md active:scale-[0.96] motion-reduce:transition-none motion-reduce:active:scale-100"
      >
        <UploadCloud strokeWidth={1.9} />
        {t('navigation.uploadDocument')}
      </Button>
    </header>
  );
};

export default GreetingHeader;
